import { Component, Element, Host, Prop, h } from '@stencil/core';
import { addStyleSettings } from '../../utils/custom-style';

@Component({
  tag: 'tambr-snackbar',
  styleUrl: 'tambr-snackbar.css',
  shadow: true,
})
export class TambrSnackbar {

  @Prop() message: string;
  @Prop() type: 'success' | 'error' | 'warning' | 'info' = 'info';
  @Prop() duration: number = 0;
  @Prop() position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' = 'bottom-right';
  @Prop() buttonLabel: string;
  @Prop() buttonAction: () => void;

  @Element() el: HTMLElement;

  private timer: any;

  componentDidLoad() {
    if ( this.duration === 0 ) return;
    this.timer = setTimeout( () => this.remove(), this.duration );
  }

  disconnectedCallback() {
    clearTimeout( this.timer );
  }

  private remove() {
    this.el.parentNode.removeChild( this.el );
  }

  onActionClick() {
    this.buttonAction();
    this.remove();
  }


  render() {
    return (
      <Host style={ addStyleSettings() }>
        <div class={`tambr-snackbar ${ this.type } ${ this.position }`}>
          <div class="message">
            <span>{ this.message }</span>
            { this.renderButton() }
          </div>
          <div class="close" onClick={ () => this.remove() }>
            <tambr-icon type="close"></tambr-icon>
          </div>
        </div>
      </Host>
    );
  }

  renderButton() {
    if ( this.buttonLabel && this.buttonAction ) {
      return <a class="action-button" onClick={ this.onActionClick.bind( this ) }>{ this.buttonLabel }</a>
    }
  }

}
